import { useEffect, useState } from 'react';
import CKEditor from '../../../../../../src/components/CKEditor/index';
import { useParams } from 'react-router';
import { useMyContentContext } from '../../../utils/myContentContext';
import QuestionEditorHeader from '../../../components/QuestionEditorHeader';
import CreateQuestion from '../../../components/CreateQuestion';
import AddQuestionProperties from '../../../components/AddQuestionProperties';
import CreateCROption from '../../../components/CreateCROption';
import { useGetQuestionMutation } from '../../../../../features/authentication/qSetApiSlice';

const AddCRQuestion = () => {
  const { questionId, courseId } = useParams();
  const [activeStep, setActiveStep] = useState(1);
  const [dateTimeBasedUniqueKey, setDateTimeBasedUniqueKey] = useState(new Date().getTime().toString());
  const [getTcrQuestion] = useGetQuestionMutation();
  const {
    setQuestion,
    sampleAnswer,
    setSampleAnswer,
    setAnswerSize,
    setMaxPoints,
    setSelectedAttributeNodes,
    setSelectedTagNodes,
    setSelectedStandardNodes,
    setSelectedTopicNodes,
    setEditAnswer,
    setOptions
  } = useMyContentContext();

  const handleStepClick = (step) => {
    setActiveStep(step);
  };

  useEffect(() => {
    if (questionId)
      getMcFillInQuestionAsync();
  }, []);

  const getMcFillInQuestionAsync = async () => {
    let option = {
      questionId: questionId,
      courseId: courseId
    };
    var response = await getTcrQuestion(option).unwrap();
    setQuestion(response.question);
    setAnswerSize(response.crAnswerSize);
    setSampleAnswer(response.crAnswer);
    setMaxPoints(response.maxPoints);
    setEditAnswer(response.editAnswer);
    setOptions(response.options);
    setSelectedTagNodes(response.properties.tags);
    setSelectedAttributeNodes(response.properties.attributes);
    setSelectedStandardNodes(response.properties.standards);
    toIdNameModel(response.properties.topics);
    setDateTimeBasedUniqueKey(new Date().getTime().toString());
  };

  const toIdNameModel = (topics)=>{
    const topicArray = topics.map(({ value, name }) => ({
      id: value,
      name
    }));
    setSelectedTopicNodes(topicArray);
  };

  return (
    <div key={dateTimeBasedUniqueKey}>
      <div className='bg-white mb-4 rounded-4'>
        <QuestionEditorHeader
          activeStep={activeStep}
          setpOnClick={handleStepClick}
          setActiveStep={setActiveStep}
          isCRQuestion={true} />
      </div>
      <div className={activeStep == 1 ? '' : 'd-none'}>
        <CreateQuestion
          isCRQuestion={true} />
      </div>
      <div className={`bg-white mb-4 rounded-4 p-4 ${activeStep == 2 ? '' : 'd-none'}`}>
        <CKEditor
          editorData={sampleAnswer}
          setEditorData={setSampleAnswer}
        />
      </div>
      {activeStep == 3 &&
                <CreateCROption />}
      {activeStep == 4 &&
                <AddQuestionProperties />}
    </div>
  );
};

export default AddCRQuestion;
